import React from 'react';
import AIEduDialog from '../../components/Dialog/AIEduDialog';
import AIEduButton from '../../components/Button/AIEduButton';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { LOGIN_PATH } from '../../router/RouteConstants';

const CreateOrganizationErrorModel = ({
    visible,
    setVisible,
    errorMessage,
}) => {
    const navigate = useNavigate();
    const [cookies, removeCookie] = useCookies();

    const clearCookies = () => {
        Object.keys(cookies).forEach((cookie) => {
            removeCookie(cookie, {
                path: '/',
                domain: window.location.hostname,
            });
        });
        navigate(LOGIN_PATH, { replace: true });
    };
    return (
        <AIEduDialog
            visible={visible}
            draggable={false}
            style={{ width: '40rem' }}
            onHide={() => {
                if (!visible) return;
                setVisible(false);
            }}
            content={
                <>
                    <div
                        className='flex justify-content-center mb-2'
                        style={{
                            fontSize: '24px',
                            fontWeight: '600',
                            color: '#ED3500',
                        }}
                    >
                        {errorMessage || 'Error Creating Organization'}
                    </div>

                    <div className='flex justify-content-center mt-5 mb-4'>
                        <AIEduButton
                            label='Go to login'
                            severity='secondary'
                            style={{ width: '15rem' }}
                            onClick={() => {
                                setVisible(false);
                                setTimeout(() => {
                                    clearCookies();
                                }, 100);
                            }}
                        />
                    </div>
                </>
            }
        />
    );
};

export default CreateOrganizationErrorModel;
